module.exports = __webpack_public_path__ + "img/header-engagementRingsGold@2x.439c2c5.webp";